import { render, staticRenderFns } from "./kyc-documents.vue?vue&type=template&id=136c993e&scoped=true"
import script from "./kyc-documents.vue?vue&type=script&lang=js"
export * from "./kyc-documents.vue?vue&type=script&lang=js"
import style0 from "./kyc-documents.vue?vue&type=style&index=0&id=136c993e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136c993e",
  null
  
)

export default component.exports